import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getUsers() {
  try {
    const resp = await axios.get("/api/users");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function searchUsers(query: object) {
  let searchQuery = getQueryString(query);
  try {
    const resp = await axios.get("/api/users/search?" + searchQuery);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getUserById(user_id: string) {
  try {
    const resp = await axios.get("/api/users/" + user_id);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createUser(user: object) {
  try {
    const resp = await axios.put("/api/users/Create/", user);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateUser(user: object) {
  try {
    const resp = await axios.post("/api/users/update/", user);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateUserRoles(userId: string, roleIds: string[]) {
  try {
    const params = new URLSearchParams();
    params.append("userGUID", userId);
    roleIds.forEach((id) => params.append("roleGUIDs", id));

    const resp = await axios.post(`/api/users/SetRoles?${params.toString()}`);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateUserOrgs(userId: string, orgIds: string[]) {
  try {
    const params = new URLSearchParams();
    params.append("userGUID", userId);
    orgIds.forEach((id) => params.append("orgGUIDs", id));

    const resp = await axios.post(`/api/users/SetOrgs?${params.toString()}`);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateUserPassword(userId: string, newPassword: string) {
  try {
    const params = new URLSearchParams();
    params.append("userId", userId);
    params.append("newPassword", newPassword);

    const resp = await axios.post(
      `/api/users/UpdatePassword?${params.toString()}`
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
